module.exports = __webpack_public_path__ + "img/astro9.13561ded.jpg";